import _ from 'lodash';
export const getDesign = (state, designId) => {
  const categories = _.keys(state.sharedDesigns.categoryItems);
  for (const categoryI in categories) {
    const category = categories[categoryI];
    const items = state.sharedDesigns.categoryItems[category];
    for (const i in items) {
      const item = items[i];
      if (item.id === designId) {
        return item;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/selectors.js